"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolGroupChurnDto = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class SchoolGroupChurnDto {
    churnDate;
}
exports.SchoolGroupChurnDto = SchoolGroupChurnDto;
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => {
        if (value === null || value === '')
            return null;
        if (value === undefined)
            return undefined;
        return new Date(value);
    }),
    (0, class_validator_1.ValidateIf)((_, value) => value != null),
    (0, class_validator_1.IsDate)({ message: 'Churn date must be a valid date' }),
    __metadata("design:type", Object)
], SchoolGroupChurnDto.prototype, "churnDate", void 0);
